import store from '../store';

export function handleErrors(res) {
  if(!res.ok) {
    throw Error(res.statusText);
  }
  
  return res;
}

export function getAuthHeader() {
  const auth = store.getters.requestAuth;

  return auth.uid + ':' + auth.hash;
}



// WEBPACK FOOTER //
// ./src/helpers/helpers.js